<template>
  <header>
    <div class="header">
      <!--Logo-->
      <div class="header-left">
        <a href="javascript:void(0)" @click.prevent class="logo">
          <img src="../../assets/logo_lam.png" width="100" height="40" alt="" />
        </a>
      </div>
      <!--/Logo-->

      <!-- Toggle button -->
      <a id="toggle_btn" href="javascript:void(0);">
        <span class="bar-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </a>
      <!-- /Toggle button -->

      <!-- Header Message -->
      <div class="page-title-box">
        <div
          :style="`font-size:${headerMessageFontSize}px`"
          v-html="headerMessage"
        ></div>
      </div>
      <!-- /Header Message -->

      <!-- Header Title -->
      <a id="mobile_btn" class="mobile_btn" href="#sidebar"
        ><i class="fa fa-bars"></i
      ></a>
      <!-- /Header Title -->

      <!-- User Account Menu -->
      <ul class="nav user-menu">
        <li class="nav-item dropdown has-arrow main-drop">
          <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
            <span class="user-img"
              ><img src="../../assets/profiles/user4.jpg" alt="" />
            </span>
            <span>{{ name }}</span>
          </a>
          <div class="dropdown-menu">
            <router-link
              :to="{ name: 'administrators' }"
              class="dropdown-item"
              v-if="loginName == 'LAMADMIN1' && role == 'admin'"
            >
              Manage Administrators
            </router-link>
            <router-link
              :to="{ name: 'passwordChange' }"
              class="dropdown-item"
              v-if="role == 'admin'"
            >
              Change Password
            </router-link>
            <a class="dropdown-item" href="#" @click.prevent="logout">Logout</a>
          </div>
        </li>
      </ul>
      <!-- /User Account Menu -->

      <!-- Mobile User Account Menu -->
      <div class="dropdown mobile-user-menu">
        <a
          href="#"
          class="nav-link dropdown-toggle"
          data-toggle="dropdown"
          aria-expanded="false"
          ><i class="fa fa-ellipsis-v"></i
        ></a>
        <div class="dropdown-menu dropdown-menu-right">
          <a
            v-if="role == 'admin'"
            class="dropdown-item"
            href="#"
            @click.prevent="$router.push({ name: 'administrators' })"
            >Manage Administrators</a
          >
          <a
            v-if="role == 'admin'"
            class="dropdown-item"
            href="#"
            @click.prevent="$router.push({ name: 'passwordChange' })"
            >Change Password</a
          >
          <a class="dropdown-item" href="#" @click.prevent="logout">Logout</a>
        </div>
      </div>
      <!-- /Mobile User Account Menu -->
    </div>
  </header>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      name: "",
      headerMessage: "",
      headerMessageFontSize: "",
      defaultFontSize: 13,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    loginName() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.LoginName;
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("lambitoken");
      window.location = "/login";
    },
    getHeaderMessage() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.tokenObj.Id,
      };
      API.getHeaderMessage(param)
        .then((response) => {
          if (response.data.success) {
            let data = response.data;
            this.headerMessage = data.headerMessage
              ? data.headerMessage.replace("\n", "<br>").replace("\r", "")
              : "";
            this.headerMessageFontSize = !data.headerMessageFontSize
              ? this.defaultFontSize
              : data.headerMessageFontSize;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    let data = JSON.parse(localStorage.getItem("lambitoken"));
    if (!data) return;
    if (data.Role == "admin") this.name = data.Name;
    else this.name = `${data.Name} (${data.EmployeeID})`;

    this.getHeaderMessage();
  },
  mounted() {
    // Variables declarations
    var $wrapper = $(".main-wrapper");

    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });
    $(".sidebar-overlay").on("click", function () {
      $("html").removeClass("menu-opened");
      $(this).removeClass("opened");
      $wrapper.removeClass("slide-nav");
      $(".sidebar-overlay").removeClass("opened");
      $("#task_window").removeClass("opened");
    });

    $(document).on("click", ".top-nav-search .responsive-search", function () {
      $(".top-nav-search").toggleClass("active");
    });

    $(".sidebar-menu ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  },
};
</script>

<style scoped>
.page-title-box {
  color: #fff;
  margin-top: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  width: 650px;
  display: table;
}
.page-title-box > div {
  display: table-cell;
  vertical-align: middle;
  line-height: 20px;
  word-spacing: -2px;
}
.header .header-left {
  width: 280px;
}
.dropdown-menu.show {
  margin-top: 0;
}

@media only screen and (min-width: 991px) {
  .mini-sidebar .header .header-left {
    width: 60px;
  }
  .mini-sidebar .header-left .logo img {
    content: url("../../assets/logo_lam_min.png");
    width: 35px;
  }
}

@media only screen and (max-width: 1280px) {
  .page-title-box {
    width: 600px;
  }
}

@media only screen and (max-width: 1200px) {
  .page-title-box {
    width: 550px;
  }
}

@media only screen and (max-width: 991.98px) {
  .header .header-left {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Header.vue